module.exports = __webpack_public_path__ + "img/01-b&r.7d94602d.png";